import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import SearchField from '../../../../components/DriveItemList/Search/Field';
import Utils from '../../../../utils';

const mapStateToProps = (state: StoreState) => {
	const {
		search,
		driveList,
		galleryInfos: { config, template: { search: searchConfig } },
	} = state;
	const galleryMeta = Utils.getGalleryMeta(driveList, config);

	return {
		search,
		isTagsListDisplayed: searchConfig && searchConfig.showTags,
		availableTags: galleryMeta.availableTags,
	};
};

export default connect(mapStateToProps)(SearchField);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/Field/index.tsx